<h3 class="ui primary header">
  Add Affiliate Type
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" appMargin marginY="10px">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>

    <!-- Add Affiliate Form -->
    <div class="ui form">
      <div class="field" [ngClass]="{ error: false }">
        <label>Company Type</label>
        <select
          name="companyType"
          id="companyType"
          [(ngModel)]="companyTypeId"
          (change)="onSelectedCompanyTypeChanged()"
        >
          <option
            *ngFor="let companyType of modal.context.companyRecords"
            [value]="companyType.companyTypeId"
          >
            {{ companyType.companyTypeName }}
          </option>
        </select>
      </div>
      <div class="field" [ngClass]="{ error: false }">
        <label>Affiliate Type</label>
        <input
          *ngIf="
            isNewAffiliateType || !affiliateTypesToChooseFrom.length;
            else isExistingAffiliateType
          "
          type="text"
          placeholder="Enter Affiliate Type"
          [(ngModel)]="affiliateType"
        />
        <ng-template #isExistingAffiliateType>
          <select
            name="affiliateType"
            id="affiliateType"
            [(ngModel)]="affiliateTypeId"
          >
            <option
              *ngFor="let type of affiliateTypesToChooseFrom"
              [value]="type.optionId"
            >
              {{ type.optionName }}
            </option>
          </select>
        </ng-template>
      </div>
      <div class="ui checkbox" [ngClass]="{ error: false }">
        <input
          type="checkbox"
          id="isNewAffiliateType"
          [(ngModel)]="isNewAffiliateType"
        />
        <label for="isNewAffiliateType">New Affiliate Type?</label>
      </div>
      <div
        *ngIf="isNewAffiliateType"
        class="field"
        [ngClass]="{ error: false }"
        appMargin
        marginT="5"
      >
        <label>Description</label>
        <textarea name="" id="" cols="30" rows="5"></textarea>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ loading: addingNewType }"
    [disabled]="addingNewType"
    (click)="submit()"
    autofocus
  >
    Add
  </button>
</div>
